import React from "react";
import { PageContainer } from "lib/components/PageContainer";
import { ErrorHandledRoute } from "lib/components/ErrorHandledRoute";

import { Customers as CustomersPage } from "./Customers";

export const Customers = () => {
  const routes = [
    { name: "Customers", link: "/customers/", disableBottomMargin: true },
  ];

  return (
    <PageContainer name="Customers" link="/customers" routes={routes}>
      <ErrorHandledRoute path="/customers/" component={CustomersPage} />
    </PageContainer>
  );
};
